<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Store Product
        </v-card-title>
        <v-card-text>
          <v-row>
            <!-- <v-col sm="4">
              <v-autocomplete
                ref="store"
                outlined
                v-model="form.store_id"
                :items="storeItems"
                label="Store"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.store_id"
              ></v-autocomplete>
            </v-col> -->
            <v-col sm="4">
              <v-autocomplete
                ref="gift"
                outlined
                v-model="form.product_id"
                :items="productItems"
                label="Product"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.product_id"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.alloted_quantity"
                outlined
                label="Allotted Quantity"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.current_quantity"
                outlined
                label="Current Quantity"
                prepend-inner-icon="mdi-card-text-outline"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Edit Store Product
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "StoreGiftEditPage",
  data() {
    return {
      form: {
        store_id: "",
        quantity: 0,
        product_id: "",
        is_active: false,
      },
      storeItems: [],
      productItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`store_products/masters`)
        .then((masters) => {
          masters = masters.data;
          // //stores masters
          // masters.stores.forEach((store) => {
          //   this.storeItems.push({
          //     id: store.id,
          //     text: store.name,
          //     value: store.id,
          //   });
          // });

          //Product masters
          masters.products.forEach((product) => {
            this.productItems.push({
              id: product.id,
              text: product.name,
              value: product.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.storeProductId;
      axios
        .get(`/store_products/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        this.form.current_quantity = this.form.alloted_quantity;
        await axios.patch(
          `/store_products/${this.$route.params.storeProductId}`,
          this.form
        );
        await this.saveUserTimestamp(this.old_json, this.form);
        this.$router.push(
          `/stores/${this.encryptIt(this.form.store_id)}/store-products`
        );

        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
